import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as CostCenters from 'cost_centers/components';
import CostCenterFormHandlers from 'cost_centers/containers/CostCenterFormHandlers';

import {
  getIsSaving,
  getIsFetching,
  getEditing,
  getIsFetchingConfig,
} from 'cost_centers/selectors';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import { getCompany, getSubcompany } from 'auth/selectors';

export class CostCentersFormContainer extends Component {
  render = () => (
    <CostCenterFormHandlers
      render={({
        isSubmitted,
        isSaving,
        handleValueChange,
        handleValidation,
        handleSubmit,
        handleRemoveYear,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        handleAddYear,
      }) => (
        <CostCenters.FormView
          subcompany={this.props.subcompany}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          isFetching={this.props.isFetching}
          handleValueChange={handleValueChange}
          handleValidation={handleValidation}
          handleSubmit={handleSubmit}
          handleRemoveYear={handleRemoveYear}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          handleAddYear={handleAddYear}
          company={this.props.company}
          costCenter={this.props.costCenter}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  costCenter: getEditing(state),
  company: getCompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(CostCentersFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/containers/CostCentersFormContainer.js